module.exports = __webpack_public_path__ + "static/media/valor3.27f98888.png";